import { render, staticRenderFns } from "./virtual-sports.vue?vue&type=template&id=3f0e6aa0"
import script from "./virtual-sports.vue?vue&type=script&lang=js"
export * from "./virtual-sports.vue?vue&type=script&lang=js"
import style0 from "./virtual-sports.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/history/virtual-sports.vue
// module id = mTGB
// module chunks = 0